var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.957,
    height: 17.97,
    viewBox: "0 0 26.957 17.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope_2_",
    "data-name": "envelope (2)",
    d: "M24.762,10.7H2.236A2.251,2.251,0,0,0,0,12.936v13.5A2.251,2.251,0,0,0,2.236,28.67H24.72a2.251,2.251,0,0,0,2.236-2.236v-13.5A2.188,2.188,0,0,0,24.762,10.7Zm-2.7,2.236-8.1,4.935a.892.892,0,0,1-.8,0L4.935,12.936ZM2.236,26.434V13.948l9.66,5.863a2.608,2.608,0,0,0,1.561.464,2.525,2.525,0,0,0,1.561-.464l9.66-5.863V26.434Z",
    transform: "translate(0 -10.7)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.36473f1cc9668d16ba462ca1f53b6e86.svg";
export { ForwardRef as ReactComponent };